import React from "react"
import { Box, Text } from "@chakra-ui/react"

const SectionHeader = ({ text }: { text: string }) => (
  <Box
    position="relative"
    textAlign="center"
    mb={8}
    css={{
      "&::before": {
        background: "#ddd",
        content: "\"\"",
        display: "block",
        height: "1px",
        position: "absolute",
        top: "50%",
        width: "100%",
      },
    }}
  >
    <Text
      textTransform="uppercase"
      fontWeight="bold"
      fontSize="lg"
      position="relative"
      bgColor="white"
      as="span"
      px={5}
      color="#9b9b9b"
    >
      {text}
    </Text>
  </Box>
)

export default SectionHeader
